import { render, staticRenderFns } from "./fbpLock.vue?vue&type=template&id=2a182874&scoped=true"
import script from "./fbpLock.vue?vue&type=script&lang=js"
export * from "./fbpLock.vue?vue&type=script&lang=js"
import style0 from "./fbpLock.vue?vue&type=style&index=0&id=2a182874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a182874",
  null
  
)

export default component.exports